export const sx = {
    root: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '7px 8px 7px 15px',
        boxShadow: 'none',
        backgroundColor: '#fff',
        "&:hover": {
            backgroundColor: '#e9f7ff'
        },
    },
    name: {
        color: '#5f5f5f'
    },
}